import triggerOne from '../../trigger/_triggerone.js';
import delegateListener from './index.js';
import undelegateListener from '../../off/_undelegatelistener.js';
import isHeldByDataKey from './_isheldbydatakey.js';
import getProp from '../../_helpers/getprop.js';
// the function is called when a data property of a Matreshka.Object is set (the key is a data key by then)
// it delegates asterisk listener for new value and undelegates it from the previous one
export default function objectSetHandler(_ref, _temp) {
  var key = _ref.key,
    previousValue = _ref.previousValue;
  var _ref2 = _temp === void 0 ? triggerOne.latestEvent.info.delegatedData : _temp,
    path = _ref2.path,
    name = _ref2.name,
    callback = _ref2.callback,
    context = _ref2.context,
    info = _ref2.info,
    object = _ref2.object;
  var item = getProp(object, key);
  // delegation is deduplicated, so a value still held by another data key keeps its listener
  if (previousValue && typeof previousValue === 'object' && !isHeldByDataKey(object, previousValue)) {
    undelegateListener(previousValue, path, name, callback, context, info);
  }
  if (item && typeof item === 'object') {
    delegateListener(item, path, name, callback, context, info);
  }
}